import { render, staticRenderFns } from "./StepTwo.vue?vue&type=template&id=0f70d08a&scoped=true&"
import script from "./StepTwo.vue?vue&type=script&lang=js&"
export * from "./StepTwo.vue?vue&type=script&lang=js&"
import style0 from "./StepTwo.vue?vue&type=style&index=0&id=0f70d08a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f70d08a",
  null
  
)

export default component.exports